<app-cta></app-cta>
<header>
    @if(isCommercePage | async) {
        <app-commerce-header></app-commerce-header>
    } @else {
        <app-header></app-header>
    }
</header>
<main page>
    <router-outlet></router-outlet>
</main>
<footer>
    <app-footer></app-footer>
</footer>
<overlay></overlay>
<layout-fab-outlet></layout-fab-outlet>
<app-notification-outlet></app-notification-outlet>
<app-market-segment-selector></app-market-segment-selector>
